import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './module/app-routing/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HashLocationStrategy, LocationStrategy } from '@angular/common'; 
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { HttpModule } from '@angular/http';
import { Cookies } from './class/cookies';
import { Service } from './class/service';
import { TabsComponent } from './component/tabs/tabs.component';
import { UppercaseDirective } from './directive/uppercase.directive';
import { EqualValidatorDirective } from './directive/equal-validator.directive';
import { LoginComponent } from './component/login/login.component';
import { DashComponent } from './component/dash/dash.component';
import { MainMenuComponent } from './component/module/main-menu/main-menu.component';
import { HomeComponent } from './component/module/home/home.component';
import { LoaderComponent } from './component/loader/loader.component';
import { MessageDialogComponent } from './component/message-dialog/message-dialog.component';
import { FilterComponent } from './component/filter/filter.component';
import { QuickSearchComponent } from './component/quick-search/quick-search.component';
import { SearchComponent } from './component/search/search.component';
import { BancosComponent } from './component/module/archivo/contabilidad/bancos/bancos.component';
import { DiasContablesComponent } from './component/module/archivo/contabilidad/dias-contables/dias-contables.component';
import { FormatoArchivoComponent } from './component/module/archivo/formato-archivo/formato-archivo.component';
import { FormatoArchivo01Component } from './component/module/archivo/formato-archivo01/formato-archivo01.component';
import { CargosComponent } from './component/module/archivo/nomina/cargos/cargos.component';
import { ConceptosComponent } from './component/module/archivo/nomina/conceptos/conceptos.component';
import { ParametrosNominaComponent } from './component/module/archivo/nomina/parametros-nomina/parametros-nomina.component';
import { SeguridadSocialComponent } from './component/module/archivo/nomina/seguridad-social/seguridad-social.component';
import { SubcodigoComponent } from './component/module/archivo/subcodigo/subcodigo.component';
import { CentroCostoComponent } from './component/module/contable/centro-costo/centro-costo.component';
import { ConfigUserSucursalComponent } from './component/module/contable/config-user-sucursal/config-user-sucursal.component';
import { ConfigBalanceGeneralComponent } from './component/module/contable/config-balance-general/config-balance-general.component';
import { ConfigEstadoResultadoComponent } from './component/module/contable/config-estado-resultado/config-estado-resultado.component';
import { ConfigFuenteComponent } from './component/module/contable/config-fuente/config-fuente.component';
import { CuentasComponent } from './component/module/contable/cuentas/cuentas.component';
import { CuentasNiifGrupoComponent } from './component/module/contable/cuentas-niif-grupo/cuentas-niif-grupo.component';
import { DepartamentoComponent } from './component/module/contable/departamento/departamento.component';
import { FormaPagoComponent } from './component/module/contable/forma-pago/forma-pago.component';
import { FormaPago01Component } from './component/module/contable/forma-pago01/forma-pago01.component';
import { FuentesComponent } from './component/module/contable/fuentes/fuentes.component';
import { MunicipioComponent } from './component/module/contable/municipio/municipio.component';
import { PaisComponent } from './component/module/contable/pais/pais.component';
import { ParametrosContabilidadComponent } from './component/module/contable/parametros-contabilidad/parametros-contabilidad.component';
import { RelaBaconFormaPagoComponent } from './component/module/contable/rela-bacon-forma-pago/rela-bacon-forma-pago.component';
import { SucursalComponent } from './component/module/contable/sucursal/sucursal.component';
import { TerceroComponent } from './component/module/contable/tercero/tercero.component';
import { TipoEgresoIngresoComponent } from './component/module/contable/tipo-egreso-ingreso/tipo-egreso-ingreso.component';
import { TipoComprobanteComponent } from './component/module/contable/tipo-comprobante/tipo-comprobante.component';
import { TipoDocumentoComponent } from './component/module/contable/tipo-documento/tipo-documento.component';
import { YearsContablesComponent } from './component/module/contable/years-contables/years-contables.component';
import { AutPagaduriaComponent } from './component/module/libranza/aut-pagaduria/aut-pagaduria.component';
import { BaseDatosComponent } from './component/module/libranza/base-datos/base-datos.component';
import { EscalaNovedadesComponent } from './component/module/libranza/escala-novedades/escala-novedades.component';
import { EstadoCreditoComponent } from './component/module/libranza/estado-credito/estado-credito.component';
import { InversionistaComponent } from './component/module/libranza/inversionista/inversionista.component';
import { LibranzaParametrizacionComponent } from './component/module/libranza/libranza-parametrizacion/libranza-parametrizacion.component';
import { PagaduriaComponent } from './component/module/libranza/pagaduria/pagaduria.component';
import { TipoNcrVsUsuariosComponent } from './component/module/libranza/tipo-ncr-vs-usuarios/tipo-ncr-vs-usuarios.component';
import { TipoNcrVsFormapagoComponent } from './component/module/libranza/tipo-ncr-vs-formapago/tipo-ncr-vs-formapago.component';


@NgModule({
  declarations: [
    AppComponent,
    DashComponent,
    TabsComponent,
    HomeComponent,
    MainMenuComponent,
    FilterComponent,
    LoaderComponent,
    LoginComponent,
    MessageDialogComponent,
    QuickSearchComponent,
    SearchComponent,
    UppercaseDirective,
    EqualValidatorDirective,
    BancosComponent,
    DiasContablesComponent,
    FormatoArchivoComponent,
    FormatoArchivo01Component,
    CargosComponent,
    ConceptosComponent,
    ParametrosNominaComponent,
    SeguridadSocialComponent,
    SubcodigoComponent,
    CentroCostoComponent,
    ConfigUserSucursalComponent,
    ConfigBalanceGeneralComponent,
    ConfigEstadoResultadoComponent,
    ConfigFuenteComponent,
    CuentasComponent,
    CuentasNiifGrupoComponent,
    DepartamentoComponent,
    FormaPagoComponent,
    FormaPago01Component,
    FuentesComponent,
    MunicipioComponent,
    PaisComponent,
    ParametrosContabilidadComponent,
    RelaBaconFormaPagoComponent,
    SucursalComponent,
    TerceroComponent,
    TipoEgresoIngresoComponent,
    TipoComprobanteComponent,
    TipoDocumentoComponent,
    YearsContablesComponent,
    AutPagaduriaComponent,
    BaseDatosComponent,
    EscalaNovedadesComponent,
    EstadoCreditoComponent,
    InversionistaComponent,
    LibranzaParametrizacionComponent,
    PagaduriaComponent,
    TipoNcrVsUsuariosComponent,
    TipoNcrVsFormapagoComponent,    
  ],
  imports: [
    HttpModule,
		BrowserModule,
    FormsModule,
		AppRoutingModule,
		ReactiveFormsModule,
		NgbModule.forRoot()
  ],
  entryComponents:[
    MainMenuComponent,
    TabsComponent,
    HomeComponent,
    BancosComponent,
    DiasContablesComponent,
    FormatoArchivoComponent,
    FormatoArchivo01Component,
    CargosComponent,
    ConceptosComponent,
    ParametrosNominaComponent,
    SeguridadSocialComponent,
    SubcodigoComponent,
    CentroCostoComponent,
    ConfigUserSucursalComponent,
    ConfigBalanceGeneralComponent,
    ConfigEstadoResultadoComponent,
    ConfigFuenteComponent,
    CuentasComponent,
    CuentasNiifGrupoComponent,
    DepartamentoComponent,
    FormaPagoComponent,
    FormaPago01Component,
    FuentesComponent,
    MunicipioComponent,
    PaisComponent,
    ParametrosContabilidadComponent,
    RelaBaconFormaPagoComponent,
    SucursalComponent,
    TerceroComponent,
    TipoEgresoIngresoComponent,
    TipoComprobanteComponent,
    TipoDocumentoComponent,
    YearsContablesComponent,
    AutPagaduriaComponent,
    BaseDatosComponent,
    EscalaNovedadesComponent,
    EstadoCreditoComponent,
    InversionistaComponent,
    LibranzaParametrizacionComponent,
    PagaduriaComponent,
    TipoNcrVsUsuariosComponent,
    TipoNcrVsFormapagoComponent,
  ],
  providers: [
    CookieService,
		Service,
		Cookies,
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts